import React from 'react'
import ReactGA from 'react-ga'
import LogoForm from './logo_form'
import NewUserForm from './new_user_form'
import BrandkitForm from './brandkit_form'
import StripeForm from './stripe_form'
import Confirmation from './confirmation'
import { Footer } from './footer'
import Header from './header'
import loaderGIF from './icons/loader.gif';
import './styles/onboarding'

export default class Onboarding extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 0,
      currentUser: this.currentUser,
      authenticityToken: this.props.authenticityToken,
      planType: this.props.brandkitDetails.planType,
      logo: null,
      company: null,
      colors: null,
      stripeToken: null,
      creditCardLastFour: null,
      paymentStatus: 'Submit Payment',
      createBrandkitLoading: false,
      initialPageLoading: true,
    };
  };

  componentWillMount () {
    const mobileWidth = 992;
    const viewWidth = window.innerWidth;
    const mobile = viewWidth < mobileWidth ? true : false;
    if (mobile && this.state.stage === 0) {
      this.setState({stage: 1})
    }

    ReactGA.initialize('UA-38312811-6');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  updateOnboarding(obj) {
    Object.keys(obj).forEach((key) => {
      this.setState({ [key]: obj[key] });
      if(key === 'stage') { ReactGA.pageview(`${window.location.pathname}/${obj[key]}${window.location.search}`);}
    });
  }

  get currentUser() {
    const {currentUser} = this.props;
    if(currentUser && currentUser.email.length > 0) {
      return currentUser;
    } else {
      return null;
    }
  }

  getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  createBrandkit(brandkitParams) {
    this.setState({createBrandkitLoading: true});

    let that = this;
    let { logo, colors, stripeToken, currentUser, planType } = this.state;
    let { slug, name, url } = brandkitParams;
    let csource = this.getParameterByName('utm_source');
    let ccampaign = this.getParameterByName('utm_campaign');
    let params =  { brandkit: { slug, name, logo, url, colors, stripeToken, planType, csource, ccampaign }};
    let xhr = new XMLHttpRequest();
    xhr.open('POST', '/brandkits', true);
    xhr.setRequestHeader("X-CSRF-TOKEN", this.state.authenticityToken)
    xhr.setRequestHeader("Content-type", 'application/json')
    xhr.onreadystatechange = function () {
      if(this.readyState == 4 && this.status == 200) {
        setTimeout(() => {window.location.href = `/${slug}`}, 1000);
      } else if (this.readyState == 4) {
        that.setState({createBrandkitLoading: false});
        swal({
          title: "Error!",
          text: 'There was an error creating your Brandfolder. Please try again or contact support!',
          type: "error"
        });
      }
    }
    xhr.send(JSON.stringify(params));
  }

  contentStage() {
    let {stage, authenticityToken} = this.state;
    if (stage === 0) {
      return <LogoForm authenticityToken={authenticityToken}
                       updateOnboarding={this.updateOnboarding.bind(this)}
                       stage={this.state.stage} />
    } else if(stage === 1) {
      return <NewUserForm updateOnboarding={this.updateOnboarding.bind(this)}
                          stage={this.state.stage}
                          currentUser={this.state.currentUser}
                          authenticityToken={authenticityToken} />

    } else if(stage === 2) {
      return <StripeForm   updateOnboarding={this.updateOnboarding.bind(this)}
                           stage={this.state.stage}
                           paymentStatus={this.state.paymentStatus}
                           brandkitDetails={this.props.brandkitDetails} />
    } else if(stage === 3) {
      return <Confirmation updateOnboarding={this.updateOnboarding.bind(this)}
                           stage={this.state.stage}
                           currentUser={this.state.currentUser}
                           creditCardLastFour={this.state.creditCardLastFour}
                           brandkitDetails={this.props.brandkitDetails} />
    } else if(stage === 4) {
      return <BrandkitForm  updateOnboarding={this.updateOnboarding.bind(this)}
                            stage={this.state.stage}
                            createBrandkit={this.createBrandkit.bind(this)}
                            createBrandkitLoading={this.state.createBrandkitLoading}
                            company={this.state.company} />
    }
  }

  navStage() {
    let {currentUser, brandkitDetails} = this.props;
    let hidePayment = brandkitDetails.planType.includes('no-cc') ? 'hidden' : '';
    return (
      <ul id='signup_steps' className='nav'>
        <li className='nav__item-logo'>
          <label className='nav__item-icon icon-logo'><span className="bff-bf-logo onboarding-bf-logo"></span></label>
          </li>
        <li className={'nav__item ' + this.activate(1)}>
          <label className='nav__item-icon icon-account'><span className="bff-person onboarding-icon"></span></label>
          <h5 className='nav__item-label'>Account</h5>
        </li>
        <li className={'nav__item ' + this.activate(2) + ' ' + hidePayment}>
          <label className='nav__item-icon icon-payment'><span className="bff-payment onboarding-icon"></span></label>
          <h5 className='nav__item-label'>Payment</h5>
        </li>
        <li className={'nav__item ' + this.activate(3) + ' ' + hidePayment}>
          <label className='nav__item-icon icon-confirmation'><span className="bff-confirmation onboarding-icon"></span></label>
          <h5 className='nav__item-label'>Confirmation</h5>
        </li>
        <li className={'nav__item ' + this.activate(4)}>
          <label className='nav__item-icon icon-build'><span className="bff-build onboarding-icon"></span></label>
            <h5 className='nav__item-label'>Build Your Brandfolder</h5>
        </li>
      </ul>
    )
  }

  activate(stage) {
    return this.state.stage === stage ? 'active' : ''
  }

  bannerStage () {
    switch (this.state.stage) {
      case 0:
        return (
          <div className='banner banner--step0'>
            <h1 className='banner__title'>Welcome!</h1>
            <h2 className='banner__text'>Let's start building your Brandfolder</h2>
          </div>
        )
      case 1:
        if (this.state.currentUser) {
          return (
            <div className='banner banner--step1'>
              <h2 className='banner__text'>Welcome Back!</h2>
              <h1 className='banner__title'>It looks like you're already logged in</h1>
            </div>
          )
        } else {
          return (
            <div className='banner banner--step1'>
              <h2 className='banner__text'>Welcome to Brandfolder!</h2>
              <h1 className='banner__title'>Create an Account</h1>
            </div>
          )
        }
      case 2:
        return (
          <div className='banner banner--step2'>
            <h1 className='banner__title'>Payment Information</h1>
          </div>
        )
      case 3:
        return (
          <div className='banner banner--step3'>
            <h1 className='banner__title'>Congrats, {this.state.currentUser.first_name}!</h1>
          </div>
        )
      case 4:
        return (
          <div className='banner banner--step4'>
            <h1 className='banner__title'>Let's build your Brandfolder</h1>
          </div>
        )
      default:
        break;
    }
  }

  renderCancel () {
    if (this.state.stage < 3) {
      return (
        <a href='/pricing' className='cancel-link link'>
          <label className='close-icon'><span className="bff-close"></span></label>
          <h4 className='link'>Cancel</h4>
        </a>
      )
    }
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <video width='90' poster={ loaderGIF }>Browser Doesn't Support HTML5 Video Tag</video>
        </div>
      )
    }

  renderStages () {
    if (this.state.initialPageLoading) {
      setTimeout(() => this.setState({initialPageLoading: false}), 1500)
      return this.renderLoader()
    } else if (this.state.createBrandkitLoading) {
      return this.renderLoader()
    } else {
      return (
        <div className='onboarding-container'>
          {this.navStage()}
          {this.bannerStage()}
          {this.contentStage()}
          <div className='background-blur'>.</div>
        </div>
      )
    }
  }

  render() {
    return (
      <div className='onboarding-component'>
        <div className='onboarding-wrapper'>
          <Header stage={this.state.stage}/>
          {this.renderStages()}
          <Footer />
        </div>
      </div>
    )
  }
}
